import React from 'react';
import PropTypes from 'prop-types';
import {
    FaFacebookSquare,
    FaTwitterSquare,
    FaYoutubeSquare,
    FaInstagram,
} from 'react-icons/fa';
import styles from './sociallinks.module.scss';

export const IconDefaults = {
    Facebook: FaFacebookSquare,
    Twitter: FaTwitterSquare,
    Youtube: FaYoutubeSquare,
    Instagram: FaInstagram,
};

const NullComponent = () => null;

const SocialLinks = ({ links = [] }) => {
    return links.length ? (
        <div className={styles.social}>
            {links.map(({ servicename, url }) => {
                const Icon = IconDefaults[servicename]
                    ? IconDefaults[servicename]
                    : NullComponent;
                return (
                    <a
                        key={servicename}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Icon />
                    </a>
                );
            })}
        </div>
    ) : null;
};

SocialLinks.propTypes = {
    links: PropTypes.array.isRequired,
};

export default SocialLinks;
